import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import { Beneficiaries, BeneficiariesError } from './Beneficiaries';
import { AddBeneficiary, AddBeneficiaryError, CodeValidationLimitReached, InvalidCode, InvalidFormatCurp, InvalidRelationship, InvestorHasAuthenticationFactorLocked, TotalPercentageExceeded } from './AddBeneficiary';
class BeneficiariesAPI extends HundredBricksAPI {
    async addBeneficiary(payload) {
        try {
            const { data } = await this.client.post('v2/profile/beneficiaries', payload);
            return new AddBeneficiary(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'TOTAL_PERCENTAGE_EXCEEDED':
                        throw new TotalPercentageExceeded({ cause: error });
                    case 'INVALID_FORMAT_CURP':
                        throw new InvalidFormatCurp({ cause: error });
                    case 'INVALID_RELATIONSHIP':
                        throw new InvalidRelationship({ cause: error });
                    case 'INVALID_CODE':
                        throw new InvalidCode({ cause: error });
                    case 'CODE_VALIDATION_LIMIT_REACHED':
                        throw new CodeValidationLimitReached({ cause: error });
                    case 'INVESTOR_HAS_AUTHENTICATION_FACTOR_LOCKED':
                        throw new InvestorHasAuthenticationFactorLocked({ cause: error });
                    default:
                        throw new AddBeneficiaryError({ cause: error });
                }
            }
            throw new AddBeneficiaryError(`Unexpected error when add beneficiary: '${error}'`);
        }
    }
    async beneficiaries() {
        try {
            const { data } = await this.client.get('v2/profile/beneficiaries');
            return data.map(item => new Beneficiaries(item));
        }
        catch (error) {
            if (error instanceof APIError) {
                throw new BeneficiariesError({ cause: error });
            }
            throw new BeneficiariesError(`Unexpected error when get beneficiaries: '${error}'`);
        }
    }
}
export default BeneficiariesAPI;
